import { loader } from 'graphql.macro';

export function loadTypeDefs() {
    return loader('../graphql/schema.local.graphql');
}
